/**
 * KARDA brand navy ramp.
 *
 * Anchored on the four historical brand hexes (navy600–900). The remaining
 * steps are derived once and committed as literals so tokens stay static data:
 *   navy950          = mix(navy900, #000, 25%)
 *   navy500..navy100 = mix(navy600, #fff, 18% / 36% / 54% / 72% / 88%)
 * (linear sRGB channel mix — equivalent to MUI lighten/darken coefficients)
 */
export const navy = {
  950: "#14151f", // derived — dark-mode app canvas
  900: "#1a1c29", // anchor — dark-mode paper
  800: "#26293B", // anchor — brand primary
  700: "#3d4260", // anchor
  600: "#4a4e69", // anchor
  500: "#6b6e84", // derived
  400: "#8b8e9f", // derived
  300: "#acaeba", // derived
  200: "#cccdd5", // derived
  100: "#e9eaed", // derived
} as const;

/**
 * Dark-mode interactive accent: the navy hue (232°) re-saturated and
 * lightened so it reads as actionable on navy surfaces instead of the
 * gray a plain lighten() of navy600 produces.
 * Derivation: main = hsl(232, 38%, 72%); light = hsl(232, 46%, 82%);
 * dark = hsl(232, 36%, 62%).
 * Contrast: main on navy900 = 6.98:1, on navy950 = 7.49:1 (WCAG AA ≥ 4.5).
 */
export const periwinkle = {
  light: "#bcc2e6", // 9.66:1 on navy900
  main: "#9ca4d3",
  dark: "#7b85c1", // 4.80:1 on navy900
} as const;
